"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableBox = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var TableColGroup_1 = require("./TableColGroup");
function TableBox(_a) {
    var columns = _a.columns, children = _a.children, classPrefix = _a.classPrefix, style = _a.style;
    return (react_1.default.createElement("table", { className: classPrefix + "-table__box", style: style },
        react_1.default.createElement(TableColGroup_1.TableColGroup, { columns: columns }),
        children));
}
exports.TableBox = TableBox;
TableBox.displayName = "TableBox";
//# sourceMappingURL=TableBox.js.map